import { render, staticRenderFns } from "./AlertModifyDoc.vue?vue&type=template&id=2ca26017"
import script from "./AlertModifyDoc.vue?vue&type=script&lang=js"
export * from "./AlertModifyDoc.vue?vue&type=script&lang=js"
import style0 from "./AlertModifyDoc.vue?vue&type=style&index=0&id=2ca26017&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports